import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { AbstractWidgetComponent, ConfigurationService, ContextChange, WidgetStyle } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { GlobalConnectAppDialog } from './global-connect-app-dialog';


@Component({
  selector: 'app-transport-registration-smartphone-connection',
  templateUrl: './transport-registration-smartphone-connection.component.html',
  styleUrls: ['./transport-registration-smartphone-connection.component.scss']
})
export class TransportRegistrationSmartphoneConnectionComponent extends AbstractWidgetComponent implements OnInit {

  private readonly allAvailableCommunicationOptions = new Array<string>('loaner', 'phone-call', 'sms', 'global-connect');
  terminalContextConstants = TerminalContextConstants;

  public showGcAppInfo;
  public isLoading;

  public qrCodeUrl: string;
  public googlePlayStoreUrl: string;
  public appleAppStoreUrl: string;

  qrWidth: number = 500;
  qrLevel: string = 'L';

  communicationOptions = new Array<String>();


  detailsFormGroup = new FormGroup({});

  showPhoneNumberDialog: boolean = false;
  showPhoneNumberInputForGlobalConnect: boolean = false;
  hidePhoneNumberInput: boolean = false;
  showHints: boolean = false;
  phoneNumberRequired: boolean = false;
  phoneNumberValid: boolean = true;

  phonenumberAllowedCountries:string[];

  phoneNumberFormGroup = new FormGroup({
    phoneNumber: new FormControl(null, [Validators.required])
  });

  constructor(
    private dialog: MatDialog,
    public cps: ConfigurationService,
    public translationService: TranslationService
  ) {
    super();

    this.googlePlayStoreUrl = environment.globalConnectGooglePlayStoreUrl;
    this.appleAppStoreUrl = environment.globalConnectAppleAppStoreUrl;

    this.detailsFormGroup.addControl('driverCommunicationOption',
      new FormControl(null, Validators.required));

    this.detailsFormGroup.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(
        value => {
          if (this.detailsFormGroup.dirty) {
            this.dashboardContext.setContextValue(
              TerminalContextConstants.driverCommunication, this.detailsFormGroup.controls.driverCommunicationOption.value);
            this.updateUiModels();
          }
          this.phoneNumberRequired = value.driverCommunicationOption == 'phone-call' || value.driverCommunicationOption == 'sms'
            || (value.driverCommunicationOption == TerminalContextConstants.DRIVER_COMMUNICATION_OWN_SMARTPHONE && this.showPhoneNumberInputForGlobalConnect);
        }
      );

    this.phoneNumberFormGroup.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(
        value => {
          if (!this.hidePhoneNumberInput) {
            this.dashboardContext.setContextValue(TerminalContextConstants.phoneNumber, value.phoneNumber);
          }
        }
      );
  }

  ngOnInit(): void {
    this.readAvailableOptions();

    this.phonenumberAllowedCountries = this.cps.getClientParamValue('tmc-yard.terminal.phone-number-field.allowed-countries', false).split(",");
  }

  onContextChange(contextChange: ContextChange) {

    if (contextChange.key === TerminalContextConstants.isLoading) {
      this.isLoading = contextChange.value;
      this.updateUiModels();
    }

    if (contextChange.key === TerminalContextConstants.gcCaseUrl) {
      this.qrCodeUrl = contextChange.value;
      this.updateUiModels();
    }

    if (contextChange.key === 'available_communication_options') {
      this.readAvailableOptions();
    }

    if (contextChange.key === 'phoneNumberValid') {
      this.phoneNumberValid = contextChange.value;
    }
  }

  readAvailableOptions() {
    const configuredOptions = new Array<string>();

    if (this.dashboardContext.getContextValue('available_communication_options') != null) {
      for (const option of this.dashboardContext.getContextValue('available_communication_options')) {
        configuredOptions.push(option);
      }
    } else {
      configuredOptions.push(...this.allAvailableCommunicationOptions);
    }
    this.communicationOptions = configuredOptions;

    this.showPhoneNumberInputForGlobalConnect = this.dashboardContext.getContextValue('showPhoneNumberInputForGlobalConnect') === true;
    this.showPhoneNumberDialog = this.dashboardContext.getContextValue('showPhoneNumberDialog') === true;
    this.phoneNumberRequired = this.detailsFormGroup.controls?.driverCommunicationOption.value == 'phone-call' || this.detailsFormGroup.controls?.driverCommunicationOption.value == 'sms'
      || (this.detailsFormGroup.controls?.driverCommunicationOption.value == TerminalContextConstants.DRIVER_COMMUNICATION_OWN_SMARTPHONE && this.showPhoneNumberInputForGlobalConnect);
    this.showPhoneNumberInputForGlobalConnect = this.dashboardContext.getContextValue('showPhoneNumberInputForGlobalConnect') === true;
    this.hidePhoneNumberInput = this.dashboardContext.getContextValue('hidePhoneNumberInput') === true;
    this.showHints = this.dashboardContext.getContextValue('showHints') === true;
  }

  onSetElementAndContext() {

    // Form zurücksetzen
    this.detailsFormGroup.reset(
      {
        driverCommunicationOption:
          this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication)
      }
    );

    this.phoneNumberFormGroup.reset({
      phoneNumber: this.dashboardContext.getContextValue(TerminalContextConstants.phoneNumber)
    });

    this.qrCodeUrl = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseUrl);
    this.updateUiModels();
  }

  public openAppOverlay(store: string, url: string, extension: string) {
    const config = new MatDialogConfig();
    config.minWidth = 800;
    config.minHeight = 600;
    config.width = '800px';
    config.height = '700px';
    config.data = {
      store,
      qrCodeUrl: url,
      extension
    };
    this.dialog.open(GlobalConnectAppDialog, config);
  }

  updateUiModels() {
    this.showGcAppInfo = this.qrCodeUrl != null &&
      this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication)
      === TerminalContextConstants.DRIVER_COMMUNICATION_OWN_SMARTPHONE;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
